import { Injectable } from '@angular/core';
import { SettingsModel } from '../../../../server/data/models/settings.model';
import { Observable } from 'rxjs';
import { ClientService } from './client/client.service';
// import { Content } from '@prisma/client';

interface Content {
  name: string;
  value: string;
}

@Injectable()
export class SettingsService extends ClientService {
  public getSettings(): Observable<SettingsModel> {
    return this.get<SettingsModel>(`${this.baseUrl}/api/settings`, undefined, {
      storageType: 'memory',
      ttlMS: 1000 * 60 * 60 * 4, // 4 hours
    });
  }

  public updateSettings(settings: SettingsModel): Observable<Response> {
    this.clearStorage();
    return this.http.post<Response>('/api/updateSettings', settings);
  }

  public getContents(): Observable<Content[]> {
    return this.get<Content[]>(`${this.baseUrl}/api/contents`, undefined, {
      storageType: 'memory',
      ttlMS: 1000 * 60 * 60 * 4, // 4 hours
    });
  }

  getContentByName(name: string): Observable<Content> {
    return this.get<Content>(
      `${this.baseUrl}/api/contentByName/${name}`,
      undefined,
      {
        storageType: 'memory',
        ttlMS: 1000 * 60 * 60 * 4, // 4 hours
      }
    );
  }

  public updateContent(content: Content): Observable<Response> {
    this.clearStorage();
    return this.http.post<Response>(
      `${this.baseUrl}/api/updateContent`,
      content
    );
  }
}
